<template>
  <div class="pa-2 space-y-2.5">
    <transfer-inventory-export-pdf ref="transferInventoryExportPdfRef" />
    <div class="action-card space-x-2.5">
      <div hidden>
        <create-transfer-inventory-request ref="editTransferInventoryRequestRef"
          @save-success="onTransferInventoryRequestSuccess">
          <template>
            <div></div>
          </template>
        </create-transfer-inventory-request>
      </div>
      <div style="display: hidden">
        <create-transfer-inventory-request v-if="authPermissions.has('store_transfers:create')"
          @save-success="onTransferInventoryRequestSuccess" />
      </div>
      <div class="space-x-2.5">
        <v-btn color="primary" v-if="authPermissions.has('store_transfers:create')" @click="exportData">Export</v-btn>
      </div>
    </div>
    <div class="transfer-card space-y-2.5" v-if="authPermissions.has('store_transfers:view')">
      <div class="space-x-2.5 toolbox">
        <div>
          <v-text-field clearable v-model="search" outlined label="search..." dense hide-details="auto"
            append-icon="mdi-magnify" />
        </div>
        <div>
          <v-text-field clearable v-model="date" outlined label="Date" type="date" dense hide-details="auto" />
        </div>
        <div>
          <v-autocomplete clearable v-model="status" :items="[
            'pending',
            'out for delivery',
            'partially delivered',
            'completed',
            'cancelled',
          ]" outlined dense label="Status" hide-details="auto" />
        </div>
        <div>
          <v-btn dense color="primary" :loading="gettingStoreTransfers" @click="getStoreTransfers">Reload</v-btn>
        </div>
      </div>

      <v-data-table :headers="headers" :data="items" dense :items="storeTransferList" :loading="gettingStoreTransfers">
        <template #item.status="{ value }">
          <store-transfer-status-chip :status="value"></store-transfer-status-chip>
        </template>
        <template #item.action="{ item }">
          <v-btn v-if="authPermissions.has('store_transfers:edit')" text
            @click="$refs.editTransferInventoryRequestRef.edit(item.id)" small dense class="ma-0 pa-0"
            :loading="fetching">
            <v-icon color="yellow darken-3">mdi-pencil</v-icon>
          </v-btn>

        </template>
        <template #item.balance="{ value }">{{ formatAccounting(value) }}</template>
      </v-data-table>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.action-card {
  display: flex;
  justify-content: space-between;
}

.toolbox {
  display: flex;
}

.transfer-card {
  border: 1px solid #CFD8DC;
  border-radius: 10px;
  padding: 10px;
}
</style>
<script>
import axios from '@/extra-functions/axios.extra'
import { mapState } from 'vuex'
import { formatAccounting } from '../../../lib/utils'
export default {
  name: 'TransferInventory',
  components: {
    storeTransferStatusChip: () => import('@/components/StoreTransferStatusChip'),
    transferInventoryExportPdf: () => import('@/views/dashboard/components/transfer-inventories/TransferInventoryExportPdf'),
    createTransferInventoryRequest: () => import('@/views/dashboard/components/transfer-inventories/CreateTransferInventoryRequest'),
  },
  data() {
    return {
      items: [],
      headers: [
        { value: 'receipt_no', text: 'Receipt No.' },
        { value: 'date', text: 'Date' },
        { value: '', text: 'Received By' },
        { value: 'to_store.name', text: 'Branch' },
        { value: '', text: 'Area Code' },
        { value: 'balance', text: 'Balance', align: 'right' },
        { value: 'status', text: 'Status' },
        { value: 'action', text: 'Action' },
      ],
      search: '',
      date: '',
      status: '',
      gettingStoreTransfers: false,
      storeTransferList: [],
    }
  },
  created() {
    this.getStoreTransfers()
  },
  computed: {
    ...mapState({
      currentStoreId: state => state.settings.storeId,
      authToken: state => state.auth.token,
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  methods: {
    exportData() {
      this.$refs?.transferInventoryExportPdfRef?.open?.()
    },
    async getStoreTransfers() {
      try {
        if (this.gettingStoreTransfers) return
        this.gettingStoreTransfers = true
        const { data } = await axios(this.authToken).get('/store-transfers', {
          params: {
            search: this.search,
            date: this.date,
            status: this.status,
          },
        })
        this.storeTransferList = data
      } catch (e) {
        this.$alertSwalError('oops something went wrong getting store transfer list retrying in 3 sec')
      } finally {
        this.gettingStoreTransfers = false
      }
    },
    formatAccounting,
    onTransferInventoryRequestSuccess() {
      this.getStoreTransfers()
    },
  },
}
</script>
